import { ModalBase } from '@repo/ui';
import { useEffect, useState } from 'react';

const COUNTDOWN_SECONDS = 10;

interface IProps {
  isOpen: boolean;
  loading: boolean;
  partnerName: string;
  toggleModal: () => void;
  onConfirm: () => void;
}

export const ModalGenerateKey = ({
  isOpen,
  loading,
  partnerName,
  toggleModal,
  onConfirm,
}: IProps) => {
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(COUNTDOWN_SECONDS);
      return;
    }

    if (countdown === 0) return;

    const timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [isOpen, countdown]);

  const isConfirmDisabled = countdown > 0;

  return (
    <ModalBase.Wrapper
      size="md"
      isOpen={isOpen}
      loading={loading}
      toggle={toggleModal}
    >
      <ModalBase.Header toggle={toggleModal} withBorderBottom>
        Gerar nova chave — {partnerName}
      </ModalBase.Header>

      <ModalBase.Body>
        <div className="d-flex flex-column gap-3">
          <div className="alert alert-warning d-flex align-items-start gap-2 mb-0">
            <i className="ri-error-warning-line fs-5 mt-1 flex-shrink-0" />
            <div>
              <strong>Atenção: esta ação é irreversível.</strong>
              <p className="mb-0 mt-1">
                Ao gerar uma nova chave, a chave atual será invalidada
                imediatamente. Todos os sistemas ou integrações que utilizarem a
                chave antiga perderão o acesso até que a substituam pela nova.
              </p>
            </div>
          </div>

          <div className="alert alert-info d-flex align-items-start gap-2 mb-0">
            <i className="ri-eye-off-line fs-5 mt-1 flex-shrink-0" />
            <div>
              <strong>A nova chave será exibida apenas uma vez.</strong>
              <p className="mb-0 mt-1">
                Por segurança, a chave gerada será mostrada somente no momento
                da criação e não poderá ser recuperada posteriormente.
                Certifique-se de copiá-la e armazená-la em um local seguro antes
                de fechar.
              </p>
            </div>
          </div>

          <p className="text-muted mb-0">
            Tem certeza que deseja gerar uma nova chave para{' '}
            <strong>{partnerName}</strong>?
          </p>
        </div>
      </ModalBase.Body>

      <ModalBase.Footer>
        <ModalBase.Actions
          loading={loading}
          goBack={toggleModal}
          actionBtnType="button"
          onConfirm={onConfirm}
          confirmBtnLabel={
            isConfirmDisabled
              ? `Gerar nova chave (${countdown}s)`
              : 'Gerar nova chave'
          }
          actionBtnColor={isConfirmDisabled ? 'secondary' : 'danger'}
        />
      </ModalBase.Footer>
    </ModalBase.Wrapper>
  );
};
